import React, { type ComponentProps } from "react";

import { cn } from "@/lib/helpers/cn";
import { tv, type VariantProps } from "tailwind-variants";

type BadgeProps = ComponentProps<"span"> & VariantProps<typeof badgeStyles>;

export function Badge2({ children, className, size, variant, ...badgeProps }: BadgeProps) {
  const { body } = badgeStyles({ size, variant });

  return (
    <span role="status" className={cn(body(), className)} {...badgeProps}>
      {children}
    </span>
  );
}

const badgeStyles = tv({
  defaultVariants: {
    size: "sm",
    variant: "neutral",
  },
  slots: {
    body: cn("tw:text-center tw:rounded-sm", "tw:font-bold tw:uppercase tw:leading-none"),
  },
  variants: {
    size: {
      xs: {
        body: "tw:h-4 tw:p-1 label-xs",
      },
      sm: {
        body: "tw:h-5 tw:p-1.5 label-xs",
      },
      md: {
        body: "tw:h-6 tw:p-1.75 label-sm",
      },
    },
    variant: {
      error: {
        body: "tw:bg-fill-error-primary tw:text-text-white",
      },
      neutral: {
        body: "tw:bg-fill-quinary tw:text-text-secondary ",
      },
      success: {
        body: "tw:bg-fill-success-primary tw:text-text-white",
      },
      warning: {
        body: "tw:bg-fill-warning-secondary tw:text-text-secondary",
      },
      navy: {
        body: "tw:bg-fill-navy-primary tw:text-text-white",
      },
      "outline-success": {
        body: "tw:border tw:border-fill-success-primary tw:bg-transparent tw:text-fill-success-primary",
      },
      "outline-neutral": {
        body: "tw:border tw:border-fill-quaternary tw:bg-transparent tw:text-text-secondary",
      },
    },
  },
});
